export const common = {
  welcome: 'Welcome',
  save: 'Save',
  cancel: 'Cancel',
  loading: 'Loading...',
  search: 'Search',
};
